import React from 'react';
import { getBarValue } from '../../utility/common';

const barCountToCssClassMapping = (count) => {
  switch (count) {
    case 2:
      return 'two-bars';
    case 3:
      return 'three-bars';
    case 4:
      return 'four-bars';
    default:
      return 'one-bar';
  }
};

export default function Signal({ value }) {
  let { barCount, colorClass } = getBarValue(value);

  return (
    <div id="shared__div__signal_0" className="signal" title={value} data-testid="signal-bar-test">
      <div
        id="shared__div__signal_1"
        className={`signal-bars mt1 sizing-box ${colorClass} ${barCountToCssClassMapping(barCount)}`}
      >
        <div id="shared__div__signal_2" className="first-bar bar"></div>
        <div id="shared__div__signal_3" className="second-bar bar"></div>
        <div id="shared__div__signal_4" className="third-bar bar"></div>
        <div id="shared__div__signal_5" className="fourth-bar bar"></div>
        {/* <div className="fifth-bar bar"></div> */}
      </div>
    </div>
  );
}
